import { render, staticRenderFns } from "./FileContent.vue?vue&type=template&id=2632cdb7&scoped=true"
import script from "./FileContent.vue?vue&type=script&lang=js"
export * from "./FileContent.vue?vue&type=script&lang=js"
import style0 from "./FileContent.vue?vue&type=style&index=0&id=2632cdb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2632cdb7",
  null
  
)

export default component.exports